import { FormBase } from 'core/components';

export default class AssignCarrierServiceAndWarehouseForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'assignedCarrierService',
					label: 'FULFILLMENTORDER.ASSIGNMODAL.CARRIERSERVICE',
					rules: 'required',
				},
				{
					name: 'assignedWarehouse',
					label: 'FULFILLMENTORDER.ASSIGNMODAL.WAREHOUSE',
					rules: 'required',
				},
				{
					name: 'useBuyShipping',
					label: 'FULFILLMENTORDER.ASSIGNMODAL.USEBUYSHIPPING',
				},
				{
					name: 'ignoreDeliverByDate',
					label: '',
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/AssignCarrierServiceAndWarehouseForm.js